import SwiperElement from "./swiper.js";
import SwiperIndicator from "./swiper-indicator.js";
import SwiperItem from "./swiper-item.js";
const Swiper = SwiperElement;
Swiper.Item = SwiperItem;
Swiper.Indicator = SwiperIndicator;
export default Swiper;
